export const baType = {
  CATEGORY1: "LOREAL_CONTRACT_LOREAL_EMPLOYEE",
  CATEGORY2: "EXTERNAL_CONTRACT_LOREAL_EMPLOYEE",
  CATEGORY3: "EXTERNAL_BA",
  HQ: "OFFICE_EMPLOYEE",
};
